import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
        <CarouselSection />
        <CardsSection />
        <FaqSection />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <CommentsSection />
        <IndexSection />
        <UpdatesSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}